import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import classnames from "classnames";
import _ from "lodash";

import { Mixpanel } from "../../../../actions/mixpanel.actions";

import styles from "./SubHeader.scss";
import arrow from "../../../../assets/images/step-separator.svg";

class SubHeader extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { items } = this.props.common.subHeader;

    return !_.isEmpty(items) ? (
      <div className={styles.subHeader}>
        <div className={styles.items}>{this.renderItems()}</div>
      </div>
    ) : null;
  }

  renderItems() {
    const { items } = this.props.common.subHeader;

    return items.map((item, index) => {
      return (
        <div className={styles.item} key={index}>
          {this.renderItem(item, index)}

          {this.renderArrow(index)}
        </div>
      );
    });
  }

  renderItem(item, index) {
    const { activeItem } = this.props.common.subHeader;

    const className = classnames(styles.caption, {
      [styles.isActive]: index === activeItem,
      [styles.isInactive]: index !== activeItem
    });

    let component = <div className={className}>{item.caption}</div>;

    if (item.url) {
      let captionId = item.caption
        .replace(/ \([\s\S]*?\)/g, "")
        .replace(/\s/g, "_")
        .toLowerCase();

      let captionText = item.caption.replace(/ \([\s\S]*?\)/g, "");

      component = (
        <Link
          id={`subheader-${captionId}`}
          to={item.url}
          onClick={() => Mixpanel.track(`Project - Subnav - ${captionText}`)}
        >
          {component}
        </Link>
      );
    }

    return component;
  }

  renderArrow(index) {
    const { items, arrows } = this.props.common.subHeader;

    return arrows && index < items.length - 1 ? (
      <img src={arrow} className={styles.arrow} />
    ) : null;
  }
}

const mapStateToProps = state => {
  return {
    member: state.admin.user,
    common: state.common
  };
};

export default connect(mapStateToProps)(SubHeader);



// WEBPACK FOOTER //
// ./src/routes/common/header/subHeader/SubHeader.js